import React from 'react';
import { connect } from 'react-redux';
import { Title, Modal } from '@common/components';
import { popIn } from '@common/utils/services';
import RentalForm from '../Form';
import { createRental } from '@resources/Rental/actions';
import { useIntl } from 'react-intl';
import { fetchModulesBySubmoduleCode } from '@resources/Module/actions';

const Create = (props) => {
	const { createRental, visible, onCancel, module } = props;
	const intl = useIntl();

	const handleSubmit = (data) => {
		return createRental(data)
			.then((response) => {
				popIn(
					'success',
					intl.formatMessage({
						id: 'message.success.rental.create',
						defaultMessage:
							'A new Rental has been successfully created',
					})
				);
				onCancel && onCancel();
			})
			.catch((err) => Promise.reject(err));
	};

	return (
		<Modal visible={visible} onCancel={() => onCancel()}>
			<Title>
				{intl.formatMessage({
					id: 'common.new.rental',
					defaultMessage: 'Create Rental',
				})}
			</Title>
			<RentalForm onSubmit={handleSubmit} {...props} module={module} />
		</Modal>
	);
};

const mapStateToProps = ({
	rentals,
	modules,
	event,
	facility,
	ministry,
	cellGroup,
	organization,
}) => {
	return {
		rentals,
		ministry,
		facility,
		modules,
		event,
		cellGroup,
		organization,
	};
};

export default connect(mapStateToProps, {
	createRental,
	fetchModulesBySubmoduleCode,
})(Create);
